<div class="h-full flex-1 overflow-hidden">
    @if (parsedToolContent()?.results?.length) {
    <div class="flex flex-col h-full overflow-hidden">
        <div class="flex flex-col gap-4 p-4 flex-shrink-0">
            @if (parsedToolContent().answer) {
            <div class="flex flex-col gap-2 bg-blue-50/70 p-4 rounded-lg border border-blue-100 shadow-sm">
                <h3 class="text-sm font-medium text-blue-800 flex items-center">
                    <app-icon [type]="'search'" [class]="'h-4 w-4 mr-2'" [source]="'lucide'" [size]="'sm'"></app-icon>
                    Answer
                </h3>
                <p class="text-sm text-zinc-700 whitespace-pre-wrap font-sans">
                    {{ parsedToolContent().answer }}
                </p>
            </div>
            }

            <div class="text-sm font-medium flex items-center">
                <app-icon [type]="'list'" [class]="'h-4 w-4 mr-2'" [source]="'lucide'" [size]="'default'"></app-icon>
                <span>Search Results ({{ parsedToolContent().results.length }})</span>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto px-4 pb-4">
            <div class="flex flex-col gap-3">
                @for (result of parsedToolContent().results; track $index) {
                @let resultType = getResultType(result);
                @let favicon = getFavicon(result.url);
                <div class="border border-zinc-200 rounded-lg shadow-sm hover:shadow transition-shadow">
                    <div class="flex gap-3 p-4">
                        @if (favicon) {
                        <img [src]="favicon" alt="" class="w-5 h-5 rounded" (error)="onFaviconError($event)" />
                        }
                        <div class="flex flex-col gap-2">
                            <div class="flex items-center">
                                <span
                                    class="text-xs px-2 py-0.5 bg-zinc-50 border border-zinc-200 rounded-lg flex items-center">
                                    <app-icon [type]="resultType.icon" [class]="'h-3 w-3 mr-1.5'" [source]="'lucide'"
                                        [size]="'sm'"></app-icon>
                                    {{ resultType.label }}
                                </span>
                            </div>
                            <a [href]="result.url" target="_blank" rel="noopener noreferrer"
                                class="text-md font-medium text-blue-600 hover:underline line-clamp-1 block">
                                {{ result.title }}
                            </a>
                            <div class="text-xs text-zinc-500 flex items-center">
                                <app-icon [type]="'globe'" [class]="'h-3 w-3 mr-1.5'" [source]="'lucide'"
                                    [size]="'sm'"></app-icon>
                                {{ cleanUrl(result.url) }}
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
    } @else {
    <div class="flex flex-col items-center justify-center h-full px-4 gap-3">
        <div
            class="w-20 h-20 rounded-full flex items-center justify-center mb-3 bg-gradient-to-b from-zinc-100 to-zinc-50 shadow-inner">
            <app-icon [type]="'search'" [class]="'h-10 w-10 text-zinc-400'" [source]="'lucide'" [size]="'xl'"></app-icon>
        </div>
        <h3 class="text-xl font-semibold">
            No Results Found
        </h3>
        <div class="bg-zinc-50 border border-zinc-200 rounded-lg p-4 w-full max-w-md text-center shadow-sm">
            <code class="text-sm font-mono break-all">
        {{ parsedToolContent().query || 'Unknown query' }}
      </code>
        </div>
        <p class="text-sm text-zinc-500">
            Try refining your search query for better results
        </p>
    </div>
    }
</div>
